import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import SelectWrap from '../../components/SelectWrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import DaysTable from './components/DaysTable';
import PeriodTable from './components/PeriodTable';
import API from '../../services/API';
import countriesObj from "../../data/countries";
import { prepareDaysReport, preparePeriodReport } from "./prepareReport";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class BidderECostCountry extends Component {
    constructor() {
        super();

        this.state = {
            countries: [],
            device: '',
            rawReport: null,
            daysReport: null,
            periodReport: null,
            reportType: 'days',
            days: [],
            sortParam: null,
            sortOrder: 1,
            isLoading: false
        };

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }

    componentDidMount() {
        API.BidderNetworkPerformance.getAffids().then(affids => this.setState({ affidValues: affids }));
    }

    componentWillUpdate(nextProps, nextState) {
        const { reportType, rawReport, daysReport, periodReport } = nextState;

        if(rawReport) {
            if(reportType === 'days' && !daysReport) {
                const newDaysReport = prepareDaysReport(rawReport);
                console.log(newDaysReport);
                this.setState({ daysReport: newDaysReport });
            }
            if(reportType === 'period' && !periodReport) {
                const newPeriodReport = preparePeriodReport(rawReport);

                this.setState({ periodReport: newPeriodReport });

                return periodReport;
            }
        }
    }

    handleFieldChange(event) {
        const { value,name } = event.target;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(filters) {
        this.setState({ isLoading: true });

        API.BidderECost.getCountry(filters).then(({ report }) => {
            this.setState({ rawReport: report, daysReport: null, periodReport: null, isLoading: false })
        });
    }

    getReport() {
        if(this.state.rawReport) {
            const { reportType } = this.state;

            if(reportType === 'days') return this.state.daysReport;
            if(reportType === 'period') return this.state.periodReport;
        }

        return null;
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    getTable() {
        const { countries, device, sortParam, sortOrder, reportType } = this.state;
        const report = this.getReport();

        if(report) {
            if(reportType === 'days') return <DaysTable reportObj={report} countries={countries} device={device} sortParam={sortParam} sortOrder={sortOrder} onSortChange={this.handleSort}/>;
            if(reportType === 'period') return <PeriodTable reportObj={report} countries={countries} device={device} sortParam={sortParam} sortOrder={sortOrder} onSortChange={this.handleSort}/>;
        }

        return <p>No Data</p>;
    }

    render() {
        const { isLoading, countries, device, reportType } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Bidder ECost Country"/>
                <Form onSubmit={this.handleSubmit}/>
                <Row>
                    <Col lg={4}>
                        <SelectWrap
                            values={{ days: 'Days', period: 'Period' }}
                            label="ReportType:"
                            name="reportType"
                            onChange={this.handleFieldChange}
                            value={reportType}
                            required
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={countriesOptions}
                            label="Countries:"
                            name="countries"
                            onChange={this.handleFieldChange}
                            value={countries}
                            multi
                            required
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={{ '': 'All', 'm': 'Mobile', 'd': 'Desktop' }}
                            label="Device:"
                            name="device"
                            onChange={this.handleFieldChange}
                            value={device}
                            required
                        />
                    </Col>
                </Row>
                {this.getTable()}
            </Container>
        );
    }
}

export default BidderECostCountry;


// WEBPACK FOOTER //
// ./src/scenes/BidderECostCountry/index.js